export function getPromptCoverTransitionName(promptId: number | string) {
  return `prompt-cover-${promptId}`;
}

export function getPromptReferenceTransitionName(
  promptId: number | string,
  index: number
) {
  return `prompt-reference-${promptId}-${index}`;
}

export function getCreationCoverTransitionName(creationId: string) {
  return `creation-cover-${creationId}`;
}
